export const GA_TRACKING_ID = 'UA-165298288-1'
export const GTM_TRACKING_ID = 'GTM-WJJGMDH'

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
  ;(window as any).gtag?.('config', GA_TRACKING_ID, {
    page_path: url,
  })
  ;(window as any).gtag?.('config', GTM_TRACKING_ID, {
    page_path: url,
  })
}

// https://developers.google.com/gtagjs/reference/event
type GoogleTagEvent =
  | 'add_payment_info'
  | 'add_to_cart'
  | 'add_to_wishlist'
  | 'begin_checkout'
  | 'checkout_progress'
  | 'exception'
  | 'generate_lead'
  | 'login'
  | 'page_view'
  | 'purchase'
  | 'refund'
  | 'remove_from_cart'
  | 'screen_view'
  | 'search'
  | 'select_content'
  | 'setup'
  | 'set_checkout_option'
  | 'share'
  | 'sign_up'
  | 'timing_complete'
  | 'view_item'
  | 'view_item_list'
  | 'view_promotion'
  | 'view_search_results'

interface IEventProps extends Record<string, any | undefined> {
  action?: GoogleTagEvent
  category?: string
  label?: string
  value?: string | number
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const sendEvent = ({ action, category, label, value, ...props }: IEventProps) => {
  ;(window as any).gtag?.('event', action, {
    ...props,
    event_category: category,
    event_label: label,
    value,
  })
}
